export const FOOTER_CONSTANTS = {
  // Footer Content
  COPYRIGHT_PREFIX: '©',
  COPYRIGHT_SUFFIX: "Dimple & Ashwin's Wedding | Made with Love 💛",
  
  // ARIA Labels
  ARIA_LABEL: 'Footer',
} as const;